import { Spinner } from '@acpaas-ui/react-components';
import PropTypes from 'prop-types';
import React from 'react';
import GenericError from '../core/GenericError';
import Pagination from '../tables/Pagination';
import OfferingsListItem from './OfferingsListItem';
import OfferingsTitle from './OfferingsTitle';

const OfferingsList = ({ items, pagination, onChange, onSelect, error, isLoading = false }) => {
  return (
    <div className="spo-o-offerings-list">
      <OfferingsTitle>
        Resultaat ({isLoading ? <Spinner className="u-inline-block" /> : pagination.total})
      </OfferingsTitle>
      {isLoading ? (
        <Spinner className="u-text-center" size="large" />
      ) : !!error ? (
        <GenericError />
      ) : items.length === 0 ? (
        <p className="u-text-light">We konden geen resultaten vinden voor uw zoekopdracht.</p>
      ) : (
        items?.map((item) => <OfferingsListItem key={item.id} {...item} onSelect={() => onSelect(item)} />)
      )}
      <Pagination
        className="u-margin-top"
        disabled={isLoading}
        onChange={onChange}
        totalElements={pagination.total}
        pageSize={pagination.size}
        page={pagination.page}
      />
    </div>
  );
};

OfferingsList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      tags: PropTypes.arrayOf(PropTypes.string)
    })
  ).isRequired,
  pagination: PropTypes.shape({
    total: PropTypes.number,
    page: PropTypes.number,
    size: PropTypes.number
  }).isRequired,
  error: PropTypes.object,
  onChange: PropTypes.func,
  isLoading: PropTypes.bool
};
export default OfferingsList;
